import * as bootstrap from "bootstrap";

const SELECTOR = '[data-bs-toggle="tooltip"]';

function initTooltips(root = document) {
    const elements = root.matches?.(SELECTOR)
        ? [root]
        : Array.from(root.querySelectorAll?.(SELECTOR) || []);

    elements.forEach((element) => {
        bootstrap.Tooltip.getOrCreateInstance(element);
    });
}

initTooltips();

export default initTooltips;
